// extracted by mini-css-extract-plugin
export default {"container":"iX-z","title":"jX-z","link":"kX-z"};